"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var LayoutComponents_1 = require("../../style/LayoutComponents");
var SubplaceStyles_1 = require("../../style/SubplaceStyles");
exports.TitleTestId = 'pane-title';
/**
 * A generic pane with a title at the top and a child (usually a data grid) that fills up the rest of the space.
 */
function PaneWithTitle(props) {
    return (React.createElement(LayoutComponents_1.VerticalFlexContainer, { fillFlexParent: true },
        React.createElement(SubplaceStyles_1.PaneTitle, null,
            React.createElement(LayoutComponents_1.HorizontalFlexContainer, null,
                React.createElement("span", { "data-tb-test-id": exports.TitleTestId }, props.title))),
        props.children));
}
exports.PaneWithTitle = PaneWithTitle;
//# sourceMappingURL=PaneWithTitle.js.map